import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { CartDrawer } from "@/components/site/CartDrawer";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import { PaymentCancel, PaymentSuccess } from "@/pages/Payment";

function Shell({ children }) {
  return (
    <>
      <Nav />
      {children}
      <Footer />
    </>
  );
}

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route path="/" element={<Shell><Home /></Shell>} />
          <Route path="/shop/:slug" element={<Shell><ProductPage /></Shell>} />
          <Route path="/payment/success" element={<Shell><PaymentSuccess /></Shell>} />
          <Route path="/payment/cancel" element={<Shell><PaymentCancel /></Shell>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <CartDrawer />
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { borderRadius: 0, background: "#18181C", border: "1px solid rgba(212,230,10,0.4)", color: "#fff" } }} />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
